import { getSECURE_API } from 'api';

const SECURE_API = getSECURE_API();

/**
 * List payout tickets — GET /api/tickets
 * @param {Object} params - { status, type, method, search, page, limit }
 */
export const listTickets = (params = {}) =>
  SECURE_API.get('/tickets', { params });

/**
 * Get a single ticket with full KYC identity — GET /api/tickets/:id
 * @param {string} id
 */
export const getTicketById = (id) =>
  SECURE_API.get(`/tickets/${id}`);

/**
 * Update a ticket status / admin notes — PATCH /api/tickets/:id
 * @param {string} id
 * @param {{ status?: string, admin_notes?: string }} payload
 */
export const updateTicket = (id, payload) =>
  SECURE_API.patch(`/tickets/${id}`, payload);
